import React from 'react';

export const Wishlist = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      className="hover:fill-black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="8" fill="white" />
      <path
        d="M21.9949 16.93C20.4953 15.1825 17.9948 14.7125 16.116 16.3127C14.2372 17.9129 13.9727 20.5883 15.4481 22.4809C16.6749 24.0544 20.3873 27.3731 21.6041 28.4473C21.7402 28.5674 21.8083 28.6275 21.8877 28.6511C21.957 28.6717 22.0328 28.6717 22.1021 28.6511C22.1815 28.6275 22.2495 28.5674 22.3857 28.4473C23.6024 27.3731 27.3149 24.0544 28.5416 22.4809C30.017 20.5883 29.7848 17.896 27.8737 16.3127C25.9626 14.7293 23.4944 15.1825 21.9949 16.93Z"
        stroke="#2A2F2F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
